"use client";

import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

function Accordion({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof AccordionPrimitive.Root>>) {
  return (
    <AccordionPrimitive.Root
      data-slot="accordion"
      className={cn("flex flex-col gap-2 p-1", className)}
      {...props}
      data-oid="yagd-mn"
    />
  );
}

function AccordionItem({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof AccordionPrimitive.Item>>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn(
        "border-border rounded-lg border relative focus-within:outline-2 focus-within:outline-ring focus-within:outline-offset-2 overflow-visible",
        className
      )}
      {...props}
      data-oid="8wxnuga"
    />
  );
}

function AccordionTrigger({
  className,
  children,
  ...props
}: Readonly<React.ComponentProps<typeof AccordionPrimitive.Trigger>>) {
  return (
    <AccordionPrimitive.Header
      data-slot="accordion-header"
      className="flex"
      data-oid="9.wr638"
    >
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          "flex flex-1 items-center justify-between gap-2 rounded-md px-4 py-3 font-medium transition-all [&[data-state=open]>svg]:rotate-180",
          "RunSheet_Beta_AccordionTrigger",
          className
        )}
        {...props}
        data-oid="jq8_flm"
      >
        {children}
        <ChevronDown
          className="h-4 w-4 shrink-0 transition-transform duration-200"
          data-oid=":m1-gb9"
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({
  className,
  children,
  ...props
}: Readonly<React.ComponentProps<typeof AccordionPrimitive.Content>>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className={cn(
        "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        className
      )}
      {...props}
      data-oid="e2:9yti"
    >
      <div className="px-4 pb-4 pt-0" data-oid="a:7f4bu">
        {children}
      </div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
